import { Box, Grid, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { getData } from "./dashboardApi";
import { Context as AuthContext } from "../../context/AuthContext";
import Total from "./assets/total.svg";
import Cancelled from "./assets/cancelled.svg";
import Delivered from "./assets/delivered.svg";
import Returned from "./assets/returned.svg";
import ReadyToShip from "./assets/readytoship.svg";
import Shipped from "./assets/shipped.svg";
import Unit from "./assets/unit.svg";
import GMV from "./assets/gmv.svg";

const Dashboard = () => {
  const [content, setContent] = useState(null);
  const { state } = useContext(AuthContext);
  const loginData = state.userData;

  useEffect(() => {
    (async () => {
      if (loginData) {
        const data = await getData(loginData.seller_id);
        setContent(data?.data);
      }
    })();
  }, [loginData]);

  return content ? (
    <Box p={2}>
      {content.historical_orders && (
        <HistoricalOrders data={content.historical_orders} />
      )}
      {content.pipeline_orders && (
        <PipelineOrders data={content.pipeline_orders} />
      )}
      {content.sales && <Sales data={content.sales} />}
    </Box>
  ) : (
    <Box p={2} display="flex"></Box>
  );
};

const HistoricalOrders = ({ data }) => {
  const { CANCELLED = 0, DELIVERED = 0, RETURNED = 0 } = data;
  const TOTAL = CANCELLED + DELIVERED + RETURNED;
  return (
    <Box mb={4}>
      <Box mb={1}>
        <Typography variant="h6">Historical Orders</Typography>
      </Box>
      <Grid container spacing={2}>
        <HalfWidthNumberCard
          icon={Total}
          title="Total"
          count={TOTAL}
          color="#fef6e5"
        />
        <HalfWidthNumberCard
          icon={Delivered}
          title="Delivered"
          count={DELIVERED}
          color="#e9fee5"
        />
        <HalfWidthNumberCard
          icon={Cancelled}
          title="Cancelled"
          count={CANCELLED}
          color="#fef3f2"
        />
        <HalfWidthNumberCard
          icon={Returned}
          title="Return/rejected"
          count={RETURNED}
          color="#f2f4fe"
        />
      </Grid>
    </Box>
  );
};

const PipelineOrders = ({ data }) => {
  const { PENDING, SHIPPED } = data;
  return (
    <Box mb={4}>
      <Box mb={1}>
        <Typography variant="h6">Pipeline Orders</Typography>
      </Box>
      <Grid container spacing={2}>
        <HalfWidthNumberCard
          icon={ReadyToShip}
          title="Ready to ship"
          count={PENDING}
          color="#f2f4fe"
        />
        <HalfWidthNumberCard
          icon={Shipped}
          title="Shipped"
          count={SHIPPED}
          color="#e9fee5"
        />
      </Grid>
    </Box>
  );
};

const Sales = ({ data }) => {
  const { gmv, units } = data;
  return (
    <Box mb={4}>
      <Box mb={1}>
        <Typography variant="h6">Sales</Typography>
      </Box>
      <Grid container spacing={2}>
        <HalfWidthNumberCard
          icon={Unit}
          title="Units"
          count={Intl.NumberFormat("en-IN", {
            notation: units > 99999 ? "compact" : "standard",
          }).format(units)}
          color="#fef3f2"
        />
        <HalfWidthNumberCard
          icon={GMV}
          title="GMV"
          count={Intl.NumberFormat("en-IN", {
            notation: gmv > 99999 ? "compact" : "standard",
            style: "currency",
            currency: "INR",
          }).format(gmv)}
          color="#fef6e5"
        />
      </Grid>
    </Box>
  );
};

const HalfWidthNumberCard = ({ title, count, icon, color }) => {
  return (
    <Grid item md={3} xs={6}>
      <Box
        borderRadius={12}
        py={2}
        px={4}
        style={{
          backgroundColor: color,
        }}
      >
        <Box display="flex" alignItems="center" spacing={2}>
          <Box flex="none" width={48} mr={1}>
            <img src={icon} alt={title} />
          </Box>
          <Box flex="auto">
            <Typography variant="subtitle2" component="span">
              {title}
            </Typography>
            <Typography
              variant="h4"
              style={{
                fontWeight: 900,
                lineHeight: "0.92em",
              }}
            >
              {count}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default Dashboard;
